/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import H4 from 'sushiweb/Typography/Heading/H4';
import { P } from 'sushiweb/Typography/Text';
import { EmptyStateContainer, MessageContainer, ZImageWrapper } from './styles';
import {
  DASHBOARD_EMPTY_IMG,
  EMPLOYEES_EMPTY_IMG,
  EMPTY_STATE_IMG,
  PAYMENTS_EMPTY_IMG,
  PROGRAMS_EMPTY_IMG,
} from '../../../../constants/images';
import { DASHBOARD, EMPLOYEES, PAYMENTS, PROGRAMS } from '../constants';

const EmptyStateV2 = ({ state, title, message, actionComponent: Comp }) => {
  let IMAGE_STATE = EMPTY_STATE_IMG;
  let isEmployees = false;
  switch (state) {
    case DASHBOARD:
      IMAGE_STATE = DASHBOARD_EMPTY_IMG;
      break;
    case EMPLOYEES:
      isEmployees = true;
      IMAGE_STATE = EMPLOYEES_EMPTY_IMG;
      break;
    case PROGRAMS:
      IMAGE_STATE = PROGRAMS_EMPTY_IMG;
      break;
    case PAYMENTS:
      IMAGE_STATE = PAYMENTS_EMPTY_IMG;
      break;
  }

  return (
    <EmptyStateContainer>
      <ZImageWrapper src={IMAGE_STATE} alt='no-data' />
      <MessageContainer isEmployees={isEmployees}>
        <H4>{title}</H4>
        <P>{message}</P>
      </MessageContainer>
      <Comp />
    </EmptyStateContainer>
  );
};

EmptyStateV2.propTypes = {
  state: PropTypes.string,
  actionComponent: PropTypes.element,
  title: PropTypes.string,
  message: PropTypes.string,
};

EmptyStateV2.defaultProps = {
  state: PropTypes.string,
  actionComponent: <></>,
  title: '',
  message: '',
};

export default EmptyStateV2;
